import { render } from "./CompaniesList.vue?vue&type=template&id=70c8e574&ts=true"
import script from "./CompaniesList.vue?vue&type=script&lang=ts"
export * from "./CompaniesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__